"use client";

import React, { Suspense } from "react";
// import TrackerPage from "./TrackerPage";
import Trackerpage from "@/component/Trackerpage";

export default function Page() {
  return (
    <Suspense fallback={<div className="p-10 text-center">Loading...</div>}>
      <Trackerpage />
    </Suspense>
  );
}
